import React from 'react';
import './BooksRequest.css';


const EditBookRequestbookForm = ({ smallModalData, changeAmount, handleSmallModal, handleChange }) => {

  this.updateForm = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    handleChange(name, value);
  };

  return (
    <div className="smallModalForm">
      <form onSubmit={changeAmount(smallModalData)}>
        <h3>Редактировать заказ книги</h3>
        <p>
          <span>Название: </span>
          {smallModalData.title}
        </p>
        <label className="smallInputLabel">Количество книг</label>
        <input
          type="number"
          name="amount"
          min="1"
          max="1000000"
          value={smallModalData.amount}
          placeholder="Количество книг"
          onChange={this.updateForm}
          required />

        <label className="smallInputLabel">Количество электронных копий</label>
        <input
          type="number"
          name="digital_amount"
          min="0"
          max="1000000"
          value={smallModalData.digital_amount}
          placeholder="Количество электронных копий"
          onChange={this.updateForm}
          required />
        <div className="d-flex justify-content-end mt-3">
          <button type="button" className="btn btn-empty mr-2" onClick={handleSmallModal(false)}>Отмена</button>
          <button type="submit" className="btn">Сохранить</button>
        </div>
      </form>
    </div>
  );
};

export default EditBookRequestbookForm;
